import { render, staticRenderFns } from "./VideoCrawlerTesting.vue?vue&type=template&id=027f3e15&scoped=true&"
import script from "./VideoCrawlerTesting.vue?vue&type=script&lang=js&"
export * from "./VideoCrawlerTesting.vue?vue&type=script&lang=js&"
import style0 from "./VideoCrawlerTesting.vue?vue&type=style&index=0&id=027f3e15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f3e15",
  null
  
)

export default component.exports